import { observer } from "mobx-react-lite";
import React from "react";

import { SolidSectionSplitter } from "Components/Form/SectionSplitter";
import { BaseModal } from "Components/Modal/BaseModal";
import { SnackBar } from "Components/SnackBar/SnackBar";
import { ApproveButton, CancelButton, RejectButton } from "Globals/Styles/Control/Buttons";
import { ReportModalStyle } from "Views/Project/Modals/Modal.Styles";
import { FormModalSection, SummaryLabel, SummaryLabelValueSection, SummaryLabelValueSectionStack, SummaryRow, SummaryValue } from "Views/Stock/Shared/Shared.styles";
import { StockAdjustmentApprovalViewModel } from "./StockAdjustmentApprovalViewModel";
import { CalculatedAdjustedStockView } from "../Shared/CalculatedAdjustedStock/CalculatedAdjustedStockView";

interface IProps {
    viewModel: StockAdjustmentApprovalViewModel;
}

export const StockAdjustmentApprovalView: React.FC<IProps> = observer((props) => {
    const viewModel = props.viewModel;

    const renderButtons = () => {
        return (
            <React.Fragment>
                {viewModel.canApprove && (
                    <ApproveButton disabled={viewModel.server.IsBusy} onClick={viewModel.approve}>
                        Approve
                    </ApproveButton>
                )}
                {viewModel.canReject && (
                    <RejectButton disabled={viewModel.server.IsBusy} onClick={viewModel.reject}>
                        Reject
                    </RejectButton>
                )}
                {viewModel.canCancel ? <CancelButton onClick={viewModel.cancel}>Cancel</CancelButton> : <CancelButton onClick={viewModel.cancel}>Close</CancelButton>}
            </React.Fragment>
        );
    };

    return (
        <BaseModal open={viewModel !== null} onClose={viewModel.cancel} title={viewModel.displayName} PaperComponent={ReportModalStyle} actions={renderButtons()}>
            <FormModalSection>
                <SummaryRow grid dc={"1fr"}>
                    <SummaryLabelValueSectionStack>
                        <SummaryLabel>Item description:</SummaryLabel>
                        <SummaryValue>{viewModel.model.description}</SummaryValue>
                    </SummaryLabelValueSectionStack>
                </SummaryRow>
            </FormModalSection>
            <SolidSectionSplitter mb="0.625rem" />
            <FormModalSection>
                <SummaryRow grid dc={"1fr"}>
                    <SummaryLabelValueSection>
                        <SummaryLabel>Adjustment:</SummaryLabel>
                        <SummaryValue>{viewModel.model.units} units</SummaryValue>
                    </SummaryLabelValueSection>
                </SummaryRow>
                <SummaryRow grid dc={"1fr"}>
                    <SummaryLabelValueSectionStack>
                        <SummaryLabel>Notes:</SummaryLabel>
                        <SummaryValue>{viewModel.model.note}</SummaryValue>
                    </SummaryLabelValueSectionStack>
                </SummaryRow>
            </FormModalSection>
            {viewModel.canDisplayCalculatedAdjustedStock && (
                <React.Fragment>
                    <SolidSectionSplitter />
                    <FormModalSection>
                        <CalculatedAdjustedStockView viewModel={viewModel.calculatedAdjustedStock!} />
                    </FormModalSection>
                </React.Fragment>
            )}
            <SolidSectionSplitter mb="0.625rem" />
            <FormModalSection>
                <SummaryRow grid dc={"1fr 1fr"}>
                    <SummaryLabelValueSection>
                        <SummaryLabel>Created by:</SummaryLabel>
                        <SummaryValue>
                            {viewModel.model.createdByUser}&nbsp;&nbsp;&nbsp;{viewModel.createdDate}
                        </SummaryValue>
                    </SummaryLabelValueSection>
                    {viewModel.canDisplayLastUpdated && (
                        <SummaryLabelValueSection>
                            <SummaryLabel>Last updated by:</SummaryLabel>
                            <SummaryValue>
                                {viewModel.model.lastUpdatedByUser}&nbsp;&nbsp;&nbsp;{viewModel.lastUpdatedDate}
                            </SummaryValue>
                        </SummaryLabelValueSection>
                    )}
                </SummaryRow>
            </FormModalSection>
            <SnackBar
                messageText={viewModel.snackMessage}
                messageType={viewModel.snackType}
                active={viewModel.snackbarState}
                closeOption={() => viewModel.setSnackbarState(false)}
                autoHideDuration={5000}
            />
        </BaseModal>
    );
});
